export const globalZ = {
  editWithAiButton: "z-[30]",
  actionDropdownMobile: "z-[95]",
  defaultDialog: "z-[100]",
};
